export const API_URL = import.meta.env.VITE_API_URL;

export const DATETIME_FORMAT = 'DD MMM YYYY HH:mm:ss';

export const DATE_FORMAT = 'DD MMM YYYY';

export const ROUTE_TRANSITION_DURATION = 500;